<template>
  <div>
    <v-row
      class="justify-center">
      <v-col
        id="card-auth-container"
        cols="10"
        md="8"
        style="max-width: 916px">
        <v-card>
          <v-row>
            <v-col md="6" class="background d-none d-md-flex">
              <v-img
                alt="background"
                src="../../assets/img/views/recoverPassword/background.jpg"
                contain
                width="300px">
              </v-img>
            </v-col>
            <v-col
              cols="12"
              class="form-container"
              md="6">
              <h1 class="text-center mb-5 mt-5 primary--text">Intercambios</h1>
              <v-form
                lazy-validation
                ref="form"
                v-model="valid"
                class="mr-5 ml-5 mb-5">
                <h3 class="mb-3 mt-2">{{$t('login.recover')}}</h3>
                <p>{{$t('login.recoverMessage')}}</p>
                <v-text-field
                  outlined
                  dense
                  class="mb-2"
                  :label="$t('general.email')"
                  :rules="rules.email"
                  v-model="email"
                  @keyup.enter="recoverPassword"
                ></v-text-field>
                <v-row>
                  <v-col>
                     <v-btn
                      color="primary"
                      outlined
                      class="float-left"
                      to="/auth/login">
                      {{$t('general.login')}}
                    </v-btn>
                    <v-btn
                      color="primary"
                      class="float-right"
                      @click="recoverPassword">
                      {{$t('general.send')}}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email :'',
      valid: true
    }
  },
  methods: {
    recoverPassword() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('requestChangePassword', {
          event: {
            context: this,
            email: this.email
          }
        })
      }
    }
  },
  props: ['lang'],
  computed: {
    rules () {
      return this.$validationRules()
    }
  }
}
</script>

<style scoped>
  .form-container {
    display: grid !important;
    align-items: center !important;
  }
</style>